import vert from '../glsl/base.vert'
import frag from '../glsl/pattern.frag'
import AFRAME from "aframe";

const textureLoader = new THREE.TextureLoader()

AFRAME.registerComponent('pattern', {
  dependencies: ['geometry'],
  schema: {
    tex: {
      type: 'asset',
    },
    loading: {
      type: 'number',
    },
    speed: {
      type: 'number',
    },
    progress: {
      type: 'number',
    },
    spd: {
      type: 'number',
    },
    mask: {
      type: 'number',
    },
    touch: {
      type: 'vec2',
    },
  },
  init: function() {

    const mesh = this.el.getObject3D('mesh')
    this.mesh = mesh
    // this._progress = 0
    //
    // this._touchX = 0.5
    // this._touchY = 1
    // this.touchX = 0.5
    // this.touchY = 1

    //console.log(777, this.touchX, this.touchY)
    // this._onTouchStart = AFRAME.utils.bind(this._onTouchStart, this)
    // this._onTouchEnd = AFRAME.utils.bind(this._onTouchEnd, this)
    // this._onTouchMove = AFRAME.utils.bind(this._onTouchMove, this)
    // window.addEventListener('touchstart', this._onTouchStart)
    // window.addEventListener('touchmove', this._onTouchMove)
    // window.addEventListener('touchend', this._onTouchEnd)

    Object.defineProperty(this, 'progress', {
      get: function() {
        return this.data.progress
      },
      set: function(val) {
        this.data.progress = val
      },
    })
    Object.defineProperty(this, 'loading', {
      get: function() {
        return this.data.loading
      },
      set: function(val) {
        this.data.loading = val
      },
    })


    let tex  = textureLoader.load(this.data.tex.getAttribute('src'))
    tex.minFilter = THREE.LinearFilter
    const textureWidth = 1108
    const textureHeight = 869

    //tex.repeat = true


    this.material = new THREE.ShaderMaterial({
      transparent: true,
      uniforms: {
        texture: {
          type: 't',
          value: tex
        },
        viewResolution: {
          type: 'v2',
          value: [window.innerWidth, window.innerHeight],
        },
        textureResolution: {
          type: 'v2',
          value: [textureWidth, textureHeight],
        },
        touch: {
          type: 'v2',
          value: [this._touchX, this._touchY],
        },

        time: {
          type: 'f',
          value: 0.0,
        },
        speed: {
          type: 'f',
          value: 0,
        },
        progress: {
          type: 'f',
          value: 0,
        },
        loading: {
          type: 'f',
          value: 0,
        },
        mask: {
          type: 'f',
          value: 0,
        },
      },
      vertexShader: vert,
      fragmentShader: frag,
    })



    this.material.depthTest = true

    mesh.material = this.material

    //mesh.material.blending = THREE.MultiplyBlending

    this.viewportResize = this.viewportResize.bind(this) // update reference so can removed listener later - TODO: should this be handled differently?

    window.addEventListener('resize', this.viewportResize) //TODO: should this be handled differently?
    setTimeout(this.viewportResize, 0) // resize on next tick once dom has loaded // TODO: to trigger when canvas element is initialized instead
  },
  update: function(oldData) {


    //this.material.uniforms.loading.value = this.data.loading
    this.material.uniforms.speed.value = this.data.speed
    this.material.uniforms.mask.value = this.data.mask

    //console.log('WWWTTFFF', this.data.progress, oldData.progress)
    //console.log(this.data.touch)

    this.material.needsUpdate = true

  },
  viewportResize: function() {
    //const viewportCanvas = document.querySelector('.a-canvas')

    //let viewWidth, viewHeight


    //viewWidth = viewportCanvas.attributes.width.value
    //viewHeight = viewportCanvas.attributes.height.value

  },
  // _onTouchStart: function(evt) {
  //   let t = evt.touches[0]
  //   this.touchX = t.pageX/window.innerWidth
  //   this.touchY = t.pageY/window.innerHeight
  //   console.log(this.touchX, this.touchY)
  // },
  // _onTouchMove: function(evt) {
  //   let t = evt.touches[0]
  //   this.touchX = t.pageX/window.innerWidth
  //   this.touchY = t.pageY/window.innerHeight
  //   console.log(this.touchX, this.touchY)
  // },
  // _onTouchEnd: function() {
  //   this.touchX = 1
  //   this.touchY = 1
  // },

  remove: function() {
    window.removeEventListener('resize', this.viewportResize)
    // window.removeEventListener('touchstart', this._onTouchStart)
    // window.removeEventListener('touchmove', this._onTouchMove)
    // window.removeEventListener('touchend', this._onTouchEnd)
  },
  tick: function(time, timeDelta) {

    // this.material.uniforms.time.value = time / 1000

    //console.log(this.data.spd, this.progress, this._progress)
    this.material.uniforms.time.value = time/1000

    // this._progress = this._progress + (this.progress - this._progress) * this.data.spd
    // //this._touchX = this._touchX + (this.touchX - this._touchX) * 0.1
    // //this._touchY = this._touchY + (this.touchY - this._touchY) * 0.1
    // this._touchX = this._touchX + (this.data.touch.x - this._touchX) * 0.2
    // this._touchY = this._touchY + (this.data.touch.y - this._touchY) * 0.2
    //console.log(this.data.touch)
    this.material.uniforms.touch.value = [this.data.touch.x, this.data.touch.y]
    this.material.uniforms.progress.value = this.data.progress
    //this.material.uniforms.loading.value = this.data.loading
    this.material.needsUpdate = true
    //console.log(time/1000/20)


  },

  tock: function(time, timeDelta) {},
  play: function() {},
  pause: function() {},
  updateSchema: function(data) {},
})
